import { useQuery } from '@apollo/client';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import { StandardAlert } from 'component/StandardAlert';
import ZoomImage from 'component/zoom_image';
import config from 'config';
import { EStatusFilter } from 'containers/style_detail/constant';
import { cache } from 'graph_ql';
import { GET_MY_STYLES } from 'graph_ql/styles/queries';
import { useEffect, useMemo, useRef, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'redux/store';
import { getListStyleStylist } from 'redux/style';
import { PATH } from 'routes/constant';
import styleItemUtils from 'utils/style_item';
import add from '../../assets/svg/icon_add.svg';
import noStyleIcon from '../../assets/svg/no_style_v2.svg';
import { setCurrentEditingItemId } from '../../redux/create-style/create-style.slice';
import MyStyleItem from './my-style-item';
import MyStylesItemsLayout from './my_styles_items_layout';
import { useStyles } from './style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import themes from 'constants/themes';
import { SwiperUtils } from '../../component/swiper/utils';

export const ALL_CONSUMER_OPTION = { fullName: 'All', id: 'all' };

function MyStylesScreen() {
    const userData = useSelector((state: RootState) => state.userDetail.me);
    const history = useHistory();
    const height: any = use100vh();
    const dispatch = useDispatch();
    const [isLastPage, setIsLastPage] = useState<any>(0);
    const [heightContent, setHeightContent] = useState<any>();
    const listStyle = useSelector((state: RootState) => state.style.listStyleStylist);
    const [displayListStyle, setDisplayListStyle] = useState<any>([]);
    const [swiperInstance, setSwiperInstance] = useState<any>([]);
    const nextListDataUpdated = useRef({ status: false, prevValue: {} });
    const prevListDataUpdated = useRef({ status: false, prevValue: {} });
    const classes = useStyles();
    const [currentFilter, setCurrentFilter] = useState<EStatusFilter>(EStatusFilter.All);
    const [filterConsumerState, setFilterConsumerState] = useState<any>({
        selected: ALL_CONSUMER_OPTION,
        valueSearch: '',
    });
    const [selectedConsumer, setSelectedConsumer] = useState<any>(ALL_CONSUMER_OPTION);
    const [showConsumerPopup, setShowConsumerPopup] = useState(false);
    const [consumersFeedbacksPopupShow, setConsumersFeedbacksPopupShow] = useState<boolean>(false);

    const generateFilterStatus = (currentFilter) => {
        switch (currentFilter) {
        case EStatusFilter.All:
            return '';
        case EStatusFilter.Draft:
            return `status:draft AND `;
        case EStatusFilter.Unlisted:
            return `status:unlisted AND `;
        case EStatusFilter.Published:
            return `status:published AND `;
        case EStatusFilter.Private:
            return `status:private AND `;
        default:
            return '';
        }
    };
    const myStyleVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        const filters =
            selectedConsumer && selectedConsumer.id !== 'all'
                ? `${generateFilterStatus(currentFilter)}user.id:${userData?.id} AND consumers.id:${
                    selectedConsumer.id
                }`
                : `${generateFilterStatus(currentFilter)}user.id:${userData?.id}`;
        return {
            index: config.algolia.algolia_prefix + 'styles',
            filters: filters,
            hit: config.algoliaHitPerPage,
            page: 0,
        };
        // eslint-disable-next-line
    }, [currentFilter, selectedConsumer]);
    const { fetchMore: fetchMyStyle, loading: loadingMyStyle } = useQuery(GET_MY_STYLES, {
        variables: myStyleVariables,
        fetchPolicy: 'cache-first',
        onCompleted(response) {
            onGetMyStyles(response, false);
        },
        onError(error) {
            console.error('get data Failed: ', error);
        },
    });

    const onGetMyStyles = (response, fetch) => {
        setIsLastPage(response?.locationsInRadius.page >= response?.locationsInRadius?.nbPages - 1);
        if (fetch) {
            dispatch(getListStyleStylist([...listStyle, ...(response?.locationsInRadius?.hits || [])]));
            if (swiperInstance.isEnd) {
                SwiperUtils.updateDisplayStyle({
                    swiperInstance,
                    forceUpdate: true,
                    displayListStyle,
                    setDisplayListStyle,
                    listStyle: [...listStyle, ...(response?.locationsInRadius?.hits || [])],
                    nextListDataUpdated,
                    prevListDataUpdated,
                });
            }
        } else {
            dispatch(getListStyleStylist(response?.locationsInRadius?.hits));
            setDisplayListStyle(response?.locationsInRadius?.hits?.slice(0, SwiperUtils.MAX_STYLES_ON_PAGE));
        }
    };

    const handleChangeSlide = async (e) => {
        if (
            e.activeIndex === displayListStyle.length - config.algoliaPrefetchThreshold &&
            listStyle.length >= config.algoliaHitItems &&
            e.activeIndex > e.previousIndex &&
            !isLastPage // currentPage index start from 0 so we need to compare with totalPage - 1
        ) {
            const data = await fetchMyStyle({
                variables: {
                    page: Math.floor(listStyle.length / config.algoliaHitItems),
                    hit: config.algoliaHitItems,
                },
            });
            onGetMyStyles(data?.data, true);
        }
        SwiperUtils.updateDisplayStyle({
            swiperInstance,
            forceUpdate: false,
            displayListStyle,
            setDisplayListStyle,
            listStyle,
            nextListDataUpdated,
            prevListDataUpdated,
        });
    };

    useEffect(() => {
        if (height) {
            if (currentFilter === EStatusFilter.Private && displayListStyle.length > 0) {
                setHeightContent(height - 202);
            } else {
                setHeightContent(height - 162);
            }
        }
    }, [height, currentFilter, displayListStyle]);

    const handleClickStyle = (styleData, itemId) => {
        if (itemId) {
            dispatch(setCurrentEditingItemId(itemId));
        }
        history.push(`${PATH.EDIT_STYLE_CANVAS}/${styleData?.taffiId}`);
    };

    const [styleInfo, setStyleInfo] = useState<any>();
    const [showPopupInfo, setShowPopupInfo] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [img, setImg] = useState<any>('');
    const handleViewInfo = (item) => {
        setShowPopupInfo(true);
        setStyleInfo(item);
    };
    const handleViewFeedbacks = (item) => {
        setConsumersFeedbacksPopupShow(true);
        setStyleInfo(item);
    };
    const handleClick = (image) => {
        setImg(image);
        setShowImage(true);
    };
    const handleClickFilterStyle = (status) => {
        if (status !== currentFilter) {
            setFilterConsumerState({
                selected: ALL_CONSUMER_OPTION,
                valueSearch: '',
            });
            setSelectedConsumer(ALL_CONSUMER_OPTION);
            setCurrentFilter(status);
        }
        if (status === EStatusFilter.Private) {
            setShowConsumerPopup(true);
        }
    };

    const generateTitleNoStyle = () => {
        if (currentFilter === EStatusFilter.Published) {
            return 'You have not published any styles';
        } else {
            return 'You have not created any styles';
        }
    };

    return (
        <>
            {showConsumerPopup && (
                <WidgetPopup
                    titlePopup={'Private Consumers list'}
                    widgetCode={WidgetCode.FilterConsumerWidget}
                    listItem={[]}
                    onClose={() => {
                        setShowConsumerPopup(false);
                        setSelectedConsumer(filterConsumerState.selected);
                    }}
                    shortPopup={false}
                    widgetProps={{
                        selectedConsumer: filterConsumerState,
                        setSelectedConsumer: setFilterConsumerState,
                    }}
                />
            )}
            {showPopupInfo && (
                <WidgetPopup
                    titlePopup={styleInfo?.collection === 'styles' ? 'Style Information' : 'Item Information'}
                    widgetCode={WidgetCode.ViewStyleInfo}
                    infoItem={styleItemUtils.getInfo(styleInfo, 'widgetpop')}
                    onClose={() => setShowPopupInfo(false)}
                    pageCode="feed"
                />
            )}
            {consumersFeedbacksPopupShow && (
                <WidgetPopup
                    titlePopup="Consumer Feedback"
                    widgetCode={WidgetCode.ConsumerFeedback}
                    onClose={() => setConsumersFeedbacksPopupShow(false)}
                    widgetProps={{
                        docId: styleItemUtils.getInfo(styleInfo)?.id,
                    }}
                />
            )}
            {showImage && <ZoomImage img={img} setShowImage={setShowImage} />}
            <MyStylesItemsLayout screenTitle="My Styles">
                <>
                    <div className={classes.buttonsWrapper}>
                        {Object.values(EStatusFilter)?.map((item) => (
                            <button
                                key={item}
                                className={currentFilter === item ? classes.activeButton : ''}
                                onClick={() => handleClickFilterStyle(item)}
                            >
                                {selectedConsumer?.id === ALL_CONSUMER_OPTION.id || item !== EStatusFilter.Private ? (
                                    item
                                ) : (
                                    <>
                                        <ExpandMoreIcon
                                            style={{
                                                color: selectedConsumer
                                                    ? themes.palette.common.white
                                                    : themes.palette.primary.main,
                                            }}
                                        />{' '}
                                        {selectedConsumer.fullName}
                                    </>
                                )}
                            </button>
                        ))}
                    </div>
                    {displayListStyle.length > 0 ? (
                        <MyStyleItem
                            listStyle={displayListStyle}
                            setListDataStyle={setDisplayListStyle}
                            heightContent={heightContent}
                            handleViewInfo={handleViewInfo}
                            handleClick={handleClick}
                            handleClickStyleItem={handleClickStyle}
                            handleChangeSlide={handleChangeSlide}
                            handleViewFeedbacks={handleViewFeedbacks}
                            setSwiperInstance={setSwiperInstance}
                        />
                    ) : (
                        <div style={{ height: `calc( ${height - 56}px - 150px)`, padding: '30px 24px 0' }}>
                            <StandardAlert
                                height={`calc( ${height - 56}px - 150px)`}
                                icon={noStyleIcon}
                                title={generateTitleNoStyle()}
                                body={'Click here to create a new style.'}
                                onButtonClick={() => history.push(PATH.CREATE_STYLE_CANVAS)}
                                buttonText={'Add a new style'}
                                isIcon={true}
                                iconButton={add}
                            />
                        </div>
                    )}
                </>
            </MyStylesItemsLayout>
            {loadingMyStyle && <LoadingDataSpinner />}
        </>
    );
}

export default MyStylesScreen;

export interface IMyStyleItem {
    id?: string;
    images: string;
    title: string;
    code: string;
    purchases?: number;
    totalSale?: number;
    views: number;
    buy?: number;
    love: number;
    hate: number;
    publish?: boolean;
    available?: boolean;
}
